import FormElementSizeRenderer from './form.el.size';
import FormElementBagetRenderer from './form.el.baget';
import FormElementListFacesRenderer from './form.el.list.faces';
import FormElementListRenderer from './form.el.list';
import FormElementCheckboxRenderer from './form.el.checkbox';
class StepRendererSelector {
    static owner;
    static sizeRenderer;
    static bagetRenderer;
    static listFacesRenderer;
    static listRenderer;
    static checkboxRenderer;
    static init(owner) {
        this.owner = owner;
        this.sizeRenderer = new FormElementSizeRenderer(owner);
        this.bagetRenderer = new FormElementBagetRenderer(owner);
        this.listFacesRenderer = new FormElementListFacesRenderer(owner);
        this.listRenderer = new FormElementListRenderer(owner);
        this.checkboxRenderer = new FormElementCheckboxRenderer(owner);
    }
    static getRenderer(step) {
        if (step.optionModel === 'size') {
            return this.sizeRenderer;
        }
        else if (step.optionModel === 'baget') {
            return this.bagetRenderer;
        }
        else if ('face' === step.optionModel) {
            return this.listFacesRenderer;
        }
        else if (step.many) {
            return this.listRenderer;
        }
        else {
            return this.checkboxRenderer;
        }
    }
}
export default StepRendererSelector;
